$(function(){
  $('.js-removeifjsactive').remove();
  $('.js-unwrapifjsactive').children().unwrap().end().remove();
});
